import { WorkspaceStructureType } from "../auth/auth.enums";

export enum WorkspaceSetupGroupId {
  STRUCTURE = "structure",
  TEAM_AND_PERMISSIONS = "teamAndPermissions",
  COMMUNITY = "community",
  FINANCE = "finance",
  GETTING_STARTED = "gettingStarted",
}

export enum WorkspaceSetupStepStatus {
  COMPLETED = "completed",
  PENDING = "pending",
}

export interface WorkspaceSetupStep {
  id: string;
  groupId: WorkspaceSetupGroupId;
  labelKey: string;
  descriptionKey?: string;
  status: WorkspaceSetupStepStatus;
  actionLabelKey?: string;
  actionHref?: string;
  priority: number;
}

export interface WorkspaceSetupGroup {
  id: WorkspaceSetupGroupId;
  labelKey: string;
  /** Optional helper note shown under the group heading (e.g. "ask your treasurer"). */
  noteKey?: string;
  completedSteps: number;
  totalSteps: number;
  status: WorkspaceSetupStepStatus;
  actionHref?: string;
  steps: WorkspaceSetupStep[];
}

export interface WorkspaceSetupRequiredProgress {
  totalSteps: number;
  completedSteps: number;
  percentage: number;
  isComplete: boolean;
  nextStep?: WorkspaceSetupStep;
  steps: WorkspaceSetupStep[];
}

export interface WorkspaceSetupProgressResponse {
  workspaceId: string | null;
  structureType: WorkspaceStructureType | null;
  visible: boolean;
  isComplete: boolean;
  required: WorkspaceSetupRequiredProgress;
  optionalGroups: WorkspaceSetupGroup[];
}
